import { AccountController } from "@/app/ui/controllers/AccountController";

const getDeviceTimezoneOffset = (): string => {
  const offsetMinutes = -new Date().getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absoluteMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absoluteMinutes / 60)
    .toString()
    .padStart(2, "0");
  const minutes = (absoluteMinutes % 60).toString().padStart(2, "0");
  return `${sign}${hours}:${minutes}`;
};

const getTimezoneValue = (values: unknown[]): string => {
  const timezone = values.find(
    (value) => typeof value === "string" && Boolean(value.trim())
  );
  return typeof timezone === "string" ? timezone.trim() : "";
};

const getCurrentAccountTimezone = (): string => {
  const accountData = AccountController.accountData;
  const timezone = getTimezoneValue([
    accountData.account_type_detail?.partnerLocation?.city?.timezone,
    accountData.account_location?.city_timezone,
    accountData.account_location?.timezone
  ]);
  return timezone || getDeviceTimezoneOffset();
};

export default getCurrentAccountTimezone;
